export default function () {
  return {
    builders: [],
    builderSearchResults: []
  }
}
